const typestore = {
    // school type:  primary  high   uni
    //scholarship type: public  independent
    //school name:  to show the scholarship card school picture when the application is not start
    namespaced: true,
    debug: true,
    state: {
        schooltype: null,
        scholarshiptype:null,
        schoolname: '',
        schoolid: '',
    },
    actions: {
    },
    mutations: {
        updateData(state, {key, data}) {
            state[key] = data;
            console.log('set schooltype data ', key+' : '+data);
            
        },
        setschooltype(state, message) {
            
            state.schooltype = message;
        },
        setscholarshiptype(state, message) {
            state.scholarshiptype = message;
        },
        remove(state, {id}) {
            state.schooltype = state.schooltype.filter(l => l.id !== id);
        }
    },
    getters: {
        getschtype: state => {
            return state;
        },
        getschooltype: state => state['schooltype'],
        getscholarshiptype: state => state.scholarshiptype,
    }
}

export default typestore;
